import React from 'react'
import { Model } from '../../three'
import { useThree } from 'react-three-fiber'
import { animated } from 'react-spring/three'
import { Math as ThreeMath } from 'three'
import usePuzzleStore from '../hooks/usePuzzleStore'
import useDragPosition from '../hooks/useDragPosition'
import ConnectionHelpers from './ConnectionHelpers'
import { wrapHandlers } from '../../../shared/utils'

function Piece({
  id,
  pieces,
  position: initialPosition,
  showConnectors = false,
  allowDrag = true
}) {
  // pull required state data from store
  const moveGroup = usePuzzleStore(
    (state) => state.moveGroup
  )

  // handler for when piece has been moved
  const handleRest = (position) => {
    moveGroup(id, position)
  }

  // set aspect for drag events
  const { size, viewport } = useThree()
  const aspect = size.width / viewport.width

  // get binding function and resulting position
  const [bind, position] = useDragPosition(
    initialPosition,
    handleRest,
    { aspect }
  )

  // dont bind handlers if drag is off
  const handlers = allowDrag ? bind() : {}

  return (
    <animated.object3D
      position={position}
      {...wrapHandlers(handlers)}
      onClick={(e) => {
        e.stopPropagation()
      }}>
      {pieces.map((m) => {
        return (
          <group key={m.id}>
            <Model
              url={m.url}
              position={m.position || [0, 0, 0]}
              rotation={m.rotation.map((r) =>
                ThreeMath.degToRad(r)
              )}
            />
            {showConnectors && (
              <ConnectionHelpers
                id={m.id}
                basePosition={m.position}
              />
            )}
          </group>
        )
      })}
    </animated.object3D>
  )
}

export default Piece
